<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical headerTitle="" :useBtnList="['btnRetrieve']" @btnRetrieve="btnRetrieve()" :showSearchPanel=true> 
          <template v-slot:body>
            <v-layout column overflow-auto>
              <v-row dense>
                <v-col cols="12">
                  <v-card class="d-flex align-center justify-center" min-height="40">
                    <v-col cols="6" ms="6" md="4">
                        <v-select label="Department" v-model="selectedDeptCd"
                            :items="deptList" :disabled="disabled" item-text="deptNm"
                            item-value="deptCd" return-object outlined dense
                            @change="getGroupList(selectedDeptCd.deptCd)" />
                    </v-col>
                    <v-col cols="6" ms="6" md="4">
                        <v-select label="Group" v-model="selectedGroupCd" :items="groupList"
                            :disabled="disabled" item-text="grpNm" item-value="grpCd"
                            return-object outlined dense />
                    </v-col>
                  </v-card>
                  <v-card class="d-flex align-center justify-center" min-height="40" outlined>
                    <v-col cols="12" ms="12" md="4">
                      <v-text-field label="Employee Code" v-model="empNo" dense outlined hide-details="auto"  :disabled="disabled" clearable/>
                        <!-- @keydown.enter="btnRetrieve()" clearable /> -->
                    </v-col>
                  </v-card>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
    <div id="loader"></div>
    <v-row no-gutters class="pa-1">
      <v-col cols="12" xs="12" sm="6" md="4" v-for="(detailPIC, i) in detailPICs" :key="i">
        <!-- <v-card class="mx-auto rounded-xl mt-3" max-width="400" color="" flat outlined shaped -->
        <v-card class="mx-auto rounded-card py-0.5 px-0.5 mt-2" max-width="400"  color="primary" flat outlined shaped @click="click(detailPIC.empNo)">
          <v-list subheader three-line>
            <v-list-item>
              <v-list-item-avatar size="90px" rounded="lg" style="padding-inline: 10px;"> 
                <v-img  style="border: 1px solid gray; " :src="detailPIC.empPic"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-subtitle>
                  <v-row>
                    <v-col style="font-size: 16px;font-weight: bold;padding: 0%;text-align: left;color: black;">
                      {{ detailPIC.enm }}</v-col>
                  </v-row>
                  <v-row class="mt-0"> <v-col style="font-size: 13px;font-weight: bold; padding: 0%; text-align: left;">
                      {{ detailPIC.empNo }} - {{ detailPIC.posNm }}</v-col>
                  </v-row>
                  <v-row class="mt-0">
                    <v-col style="font-size: 13px; padding: 0%; text-align: left;">
                      <v-icon small>mdi-phone</v-icon>
                      {{ detailPIC.tel }}
                    </v-col>
                  </v-row>
                  <v-row class="mt-0">
                    <v-col style="font-size: 13px; padding: 0%; text-align: left;">
                      <v-icon small>mdi-email</v-icon>
                      {{ detailPIC.emailAdd }}
                    </v-col>
                  </v-row>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <div class="pa-4 text-center">
    <v-dialog v-model="dialogPic" width="auto">
      <v-card flat shaped>
        <v-row class="headline pop_bar_bg" primary-title >
              <v-card-title class = "flex text-center">
                Profile.
              </v-card-title>
              <v-spacer />
              <v-card-actions class="">
                <v-btn style="height: 30px;width: 30px;" color="rgb(2, 126, 22)" @click="btnClose()">
                  <v-icon dark>
                    mdi-close-circle-outline
                  </v-icon>
                </v-btn>
              </v-card-actions>
           </v-row>
        <template>
          <v-card v-for="(detail, i) in details" :key="i">
            <v-row>
              <v-col cols="4" style="padding: 1%;"> 
                  <v-list-item-avatar size="90px" rounded="lg" style="padding-inline: 10px;"> 
                    <v-img  style="border: 1px solid gray; " :src="detail.empPic"></v-img>
                  </v-list-item-avatar>
              </v-col>
              <v-col cols="8">
                <v-list-item-content>
                  <v-list-item-title style="font-family: 'Times New Roman'; font-size:18px;font-weight: bold;">
                    {{ detail.enm }}
                  </v-list-item-title >
                  <v-list-item-subtitle>
                    <v-row class="mt-0">
                      <v-col style="font-size: 13px; padding: 0%; text-align: left;">
                        <v-icon small>mdi-phone</v-icon>
                        {{ detail.tel }}
                      </v-col>
                    </v-row>
                    <v-row class="mt-0">
                      <v-col style="font-size: 13px; padding: 0%; text-align: left;">
                        <v-icon small>mdi-email</v-icon>
                        {{ detail.emailAdd }}
                      </v-col>
                    </v-row>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
            </v-row>
            <v-card> 
              <div style="padding:5px; border:1px solid rgb(78, 187, 68);">
                <v-row class="mt-0">
                  <v-col style="padding: 5px;">
                    <v-text-field v-model=detail.deptNm label="Department" outlined readonly height="25px" dense></v-text-field>
                  </v-col>
                  <v-col v-if="detail.rtId == '7'" style="padding: 5px;">
                    <v-text-field v-model=detail.grpNm label="Group" outlined readonly height="25px" dense></v-text-field>
                  </v-col>
                  <v-col v-else style="padding: 5px;">
                    <v-text-field v-model=detail.section label="Group" outlined readonly height="25px"
                      dense></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                  <v-col style="padding: 5px;">
                    <v-text-field v-model=detail.ocptNm label="Occupation" outlined readonly height="25px" dense></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                  <v-col style="padding: 5px;">
                    <v-text-field v-model=detail.appNm label="Assignment" outlined readonly height="25px" dense></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                  <v-col style="padding: 5px;">
                    <v-text-field v-model=detail.entrdt label="Entry Company Day" outlined readonly height="25px" dense></v-text-field>
                  </v-col>
                  <v-col style="padding: 5px;">
                    <v-text-field v-model=detail.brth label="Birthday" outlined readonly height="25px" dense></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                  <v-col style="padding: 5px;">
                    <v-text-field v-model=detail.insurance label="Insurance" outlined readonly height="25px" dense></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                  <v-col style="padding: 5px;">
                    <v-text-field v-model=detail.addr label="Current Address" outlined readonly height="25px" dense></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                  <v-col style="padding: 5px;">
                    <v-text-field v-model=detail.permlNm label="Hometown" outlined readonly height="25px" dense></v-text-field>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-card>
        </template>
      </v-card>
    </v-dialog>
  </div>
    <v-btn v-show="scY > 50" fab small color="primary" app fixed right bottom @click="scrollToTop()">
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>
    <VueToastify :notifyAction="notifyAction"></VueToastify>
  </v-container>
</template>

<script>

import DxDateBox from 'devextreme-vue/date-box'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iButton from '@/components/common/iButton.vue'
import { getAuthor, getGroup } from '@/api/view/mis/10/v10aAuthor.js';
import { getv10a1000List, getDeptList, getGroupList, vni2unicode, getEmpPic, getEmpGrpCD  } from '@/api/view/mis/10/v10a1000.js'
import { getDateFormat, getCurrentDate } from '@/utils/common.js'
import dayjs from 'dayjs';
import notify from 'devextreme/ui/notify'
import baseview from '@/components/base/baseview.vue'
import VueToastify from '@/components/toastify/VueToastify.vue'

export default {
  mixins: [baseview],
  components: {
    ICardVertical,
    DxDateBox,
    VueToastify
  },
  data: () => ({
    cellVisible: false,
    listVisibility: false,
    visible: true,
    disabled: false,
    details: [],
    empNo: '',
    dialogPic: false,
    detailPICs: [],
    selectedDeptCd: '',
    deptList: [],
    selectedGroupCd: '',
    groupList: [],
    picInfor: '',
    addr: '',
    date: null,
    deptAuthor: '',
    scTimer: 0,
    scY: 0,
    useYn: '',
  }),


  mounted() {
    this.getDptList().then(() => {
      this.getGroupList(this.selectedDeptCd.deptCd);
    });
    this.author(this.$store.state.user.userId);
    window.addEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll: function () {
      if (this.scTimer) return;
      this.scTimer = setTimeout(() => {
        this.scY = window.scrollY;
        clearTimeout(this.scTimer);
        this.scTimer = 0;
      }, 100);
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    notifyAction(notifyInfo, action) {
      this.$EventBus.$emit(`${this.$route.meta.menu_id}_notifyAction`, { notifyInfo: notifyInfo, action: action })
    },

    click(empNo) {
      this.details = []
      this.doDetail(empNo)
      this.dialogPic = true
    },

    async getGroupList(deptCd) {
          let params = {
              deptCd: deptCd == ""? "%": deptCd,
          }
          //console.log('params', params)    

          await getGroupList(params).then(res => {
              this.groupList = res.list
              this.groupList.unshift({
                  grpCd: '%',
                  grpNm: 'All'
              })
              this.selectedGroupCd = this.groupList[0]
          })
    },

    async getDptList() {
      const res = await getDeptList({});
      this.deptList = res.list;
      this.deptList.unshift({ deptCd: '%', deptNm: 'All' });
      this.selectedDeptCd = this.deptList[0];
    },

    async author(empNo) {
            let params = {
                menuId: 'v10a1000',
                empNo: empNo,
                tabNo: '99',
                div: '1'
            }
            await getAuthor(params).then(res => {
                res.list.forEach(e => {
                    this.useYn = e.useYn
                });
            })

            await getGroup(params).then(res => {
                res.list.forEach(e => {
                    this.grpCd = e.grpCd
                });
            })
            
            if (this.useYn != 'Y' || this.useYn== null) {
                this.disabled = true
                this.empNo = empNo
            }
        },

    async doDetail(empNo) {
      let params = {
        empNo: empNo,
        deptCd: this.selectedDeptCd.deptCd,
        grpCd: this.selectedGroupCd.grpCd
      }

      loading(true);
      await getv10a1000List(params).then(res => {
        let list = [] ;
        let cnt = 1; 
      
        res.list.forEach(e => {
            this.empPic = {}
            this.empPic = getPic(e.empPic) ; 
            list.push(
              {
                id: cnt++, empNo: e.empNo, mobile: e.mobile, grpNm: e.grpNm, grpCd: e.grpCd,
                deptNm: e.deptNm, section: e.section,
                enm: e.enm, tel: e.tel, posNm: e.posNm, addr: !e.addr ? '' : e.addr,
                entrdt: e.entrdt, brth: e.brth, ocptNm: e.ocptNm, insurance: e.insurance,
                emailAdd: e.emailAdd, bus: e.bus, ally: e.ally, cccd: e.cccd,
                cdPrt: e.cdPrt, schlNm: e.schlNm, majorNm: e.majorNm, appNm: e.appNm,
                permlNm: e.permlNm, rtId: e.rtId,
                empPic: this.empPic
              }
            )
          // })
        });
        this.details = list
      }).finally(() => {

        loading(false);

      })
    },

    btnClose() {
      this.visible = true
      this.listVisibility = false
      this.dialogPic = false
    }, 

    btPIC() {
      this.dialogPic = false
    },

    btnRetrieve() {
      this.getv10a1000List()
    },


    async getv10a1000List() {

      let params = {
        empNo: !this.empNo ? '' : this.empNo,
        deptCd: this.selectedDeptCd.deptCd,
        grpCd: !this.selectedGroupCd.grpCd ? '': this.selectedGroupCd.grpCd
      }
      
      //console.log('Param ' , params)
      
      if (params.deptCd == '%' && (params.empNo == '' || !params.empNo ) ) {
        this.vToastify(this.$t('Please select Dept code'), 'warn')
        return
      }
      
      if (params.grpCd == '%' && parseInt(params.deptCd) > 5000 && (params.empNo == '' || !params.empNo )) {
        this.vToastify(this.$t('Please select Group code'), 'warn')
        return
      }

      loading(true);
      await getv10a1000List(params).then(res => {

        let list = []
        let cnt = 1;

        //console.log('res List ' , res.list)

        res.list.forEach(e => {
            this.empPic = {}
            this.empPic = getPic(e.empPic) ; 
            list.push(
              {
                id: cnt++, empNo: e.empNo, mobile: e.mobile, grpNm: e.grpNm, deptNm: e.deptNm,
                enm: e.enm, tel: e.tel, posNm: e.posNm, addr: !e.addr ? '' : e.addr,
                emailAdd: e.emailAdd, dspsNm: !e.dspsNm ? '' : e.dspsNm, ocptNm: e.ocptNm,
                section: e.section, rtId: e.rtId,
                empPic: this.empPic
              }
            )
        });
        this.detailPICs = list
      }).finally(() => {

        loading(false);

      })
    },

    getEmpPicture(empno) {
      try {
        let params = {
          deptCd: "",
          grpCd: "",
          appCd: "",
          empNo: empno,
        }
        getEmpPic(params).then(res => {
          this.picInfor = res.body;
          return res.body;
        })
      } finally {
      }
    },

  },  
};

function loading(show){
  if(show)
      document.getElementById("loader").style.display = "block";
  else
      document.getElementById("loader").style.display = "none";
} ;

function getPic(strBase64) {
      let base64Encode = "data:image/png;base64," + strBase64;
      return base64Encode;
  }

</script>
<style>
* {
  margin: 0;
  padding: 0;
  scroll-behavior: smooth;
}

.rounded-card {
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.pop_bar_bg {
    border-radius: 0px;
    background: linear-gradient(90deg, #72f788 0%,rgb(2, 126, 22) 100%);
    color: #ffffff !important;
    font-weight: bold;
    font-family: "HDHyundai_Logo-Bold";
    font-size: 14px !important;
    padding: 0px;
}
  

   /* Center the loader */
#loader {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  width: 120px;
  height: 120px;
  margin: -76px 0 0 -76px;
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
  display: none;
}

@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Add animation to "page content" */
.animate-bottom {
  position: relative;
  -webkit-animation-name: animatebottom;
  -webkit-animation-duration: 1s;
  animation-name: animatebottom;
  animation-duration: 1s
}

@-webkit-keyframes animatebottom {
  from { bottom:-100px; opacity:0 } 
  to { bottom:0px; opacity:1 }
}

@keyframes animatebottom { 
  from{ bottom:-100px; opacity:0 } 
  to{ bottom:0; opacity:1 }
}
</style>